<app-task *ngFor="let task of tasks" [task]="task"></app-task>
